import React from "react";
// import "../../styles/components/TabBar.sass";

const TabBar = props => {
  const { handleClick, selected, options, children, style, classes, tabStyles } = props;

  return (
    <div className={classes}>
      <div className="tabs-wrapper is-hidden-tablet" style={style}>
        {options.map((item, index) => {
          const isTabActive = selected === index;
          return (
            <button
              key={index}
              style={{ width: `${100 / options.length}%` }}
              className={`tab ${isTabActive ? "is-tab-active" : "is-ghost"} button `}
              onClick={e => handleClick(e, parseInt(index))}
            >
              <span key={0} className="tab-span regular-txt vertically-centered is-size-5" style={tabStyles}>
                {item}
              </span>
            </button>
          );
        })}
        {children}
      </div>
      <div className="tabs-wrapper is-hidden-mobile" style={style}>
        {options.map((item, index) => {
          const isTabActive = selected === index;
          return (
            <button
              type="button"
              key={index}
              style={{ width: `${100 / options.length}%` }}
              className={`tab ${isTabActive ? "is-tab-active" : "is-ghost"} button `}
              onClick={e => handleClick(e, parseInt(index))}
            >
              <span data-cy={`data-cy-tab-${index}-value`} key={0} className="tab-span regular-txt vertically-centered is-size-4">
                {item}
              </span>
            </button>
          );
        })}
        {children}
      </div>
    </div>
  );
};

export default TabBar;
